<template>
  <div>
    <el-row>
      <h2>结算模式管理</h2>
    </el-row>
    <el-row>
      <el-transfer v-model="usedSettlementModeList" :data="allSettlementModeList"
        :props="{ key: 'SETTLEMENT_ID', label: 'SETTLEMENT_NAME' }">
      </el-transfer>
    </el-row>
    <el-button @click="submit" style="margin-top: 20px;">提交</el-button>
  </div>
</template>
<script>
import { getTCSettlementMode, getBasicSettlementMode, configureTCSelectedSettlementMode } from '@/api/settlementModeManagement';


export default {
  data() {
    return {
      usedSettlementModeList: [],
      allSettlementModeList: [],
    };
  },
  methods: {
    getUsedSettlementModeList() {
      getTCSettlementMode().then((res) => {
        this.usedSettlementModeList = [...res.map(({ SETTLEMENT_ID }) => SETTLEMENT_ID)];
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
    getUnusedSettlementModeList() {
      getBasicSettlementMode().then((res) => {
        this.allSettlementModeList = res;
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
    submit() {
      const params = {
        TC_SETTLEMENT_INFO: this.allSettlementModeList.filter(({ SETTLEMENT_ID }) => this.usedSettlementModeList.includes(SETTLEMENT_ID)),
      };
      configureTCSelectedSettlementMode(params).then(() => {
        this.$message.show({ text: '配置成功', type: 'success' });
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
  },
  created() {
    this.getUsedSettlementModeList();
    this.getUnusedSettlementModeList();
  },

};
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/settlementModeManagement.vue